<template>
  <div :titleList="titleList" :tabs="tabs" :treeData="treeData" :defaultPersonList="defaultPersonList" :activeName="tabActive" :defaultPersonListChecked="defaultPersonListChecked" :showCheckBox="showCheckBox" :personList="personList" :filterText="filterText">
    <tabs @tabChange="tabChange" :activeName="tabActive">
      <el-tab-pane v-for="tab in tabs" :label="tab.label" :name="tab.name" :key="tab.name">
        <!--公共病例库-->
        <collapse @changeColl="changeColl" v-if="isPerson == '0'" :sCollActiveName="catalogSubType">
          <div style="height:40px;">
            <radius-input @searchClick="searchClick"></radius-input>
          </div>
          <el-collapse-item v-for="(item, index) in titleList" :key="index" :title="item.title" :name="item.name">
            <tree :defaultChecked="defaultChecked" :showCheckBox="showCheckBox" :filterText="filterText" :data="treeData" @checkTree="checkTree" @treeNodeClick="treeNodeClick"></tree>
          </el-collapse-item>
        </collapse>
        <!--个人病例库-->
        <div  class=" coll" v-if="isPerson == '1'">
          <div class="searchWidth" style="height:40px;width:85%; display: inline-block;">
            <radius-input @searchClick="searchClick"></radius-input>
          </div>
          <div style="height:40px;width: 40px; display: inline-block;float: right;">
            <i @click="addPersonList" style="font-size: 20px;cursor: pointer;margin-top: 2px;" class="el-icon-circle-plus"></i>
          </div>
          <div class="person_medical_record_list_content">
            <el-checkbox-group v-if="showCheckBox" v-model="personChecked">
              <el-checkbox style="width:100%;margin-left:0;text-indent:10px;" :label="item.id" :key="item.id" v-for="item in personList">
                <p :title="item.catalogName" class="checkbox_list person_medical_record_list" style="text-indent:0;">
                  <span>{{item.catalogName}}</span>
                  <i @click.self="delPerson(item)" class="del_medical">删除</i>
                </p>
              </el-checkbox>
              <!-- <p class="person_medical_record_list" @click="personClick(item.id)" :key="item.id" v-for="item in personList">
                <i @click="delPerson(item)" class="del_medical">删除</i>
              </p> -->
            </el-checkbox-group>
            <p v-else :title="item.catalogName" class="person-item person_medical_record_list" :class="{isActive: index === i}" @click="personClick(item, index)" :key="item.id" v-for="(item, index) in personList">
                <span class="person-item-span">{{item.catalogName}}</span>
                <i @click="delPerson(item)" class="del_medical">删除</i>
            </p>
          </div>
        </div>
      </el-tab-pane>
    </tabs>
  </div>
</template>

<script>
  import collapse from '@/components/common/collapse/collapse'
  import tabs from '@/components/common/tabs/tabs'
  import radiusInput from '@/components/common/radiusInput/radiusInput'
  import tree from '@/components/common/tree/tree'

  export default {
    components: {
      radiusInput,
      collapse,
      tabs,
      tree
    },
    props: {
      tabActive:{
        type: String,
        default: '0'
      },
      catalogSubType:{
        type: String,
        default: '1'
      },
      treeData: {
        type: Array,
        default() {
          return []
        }
      },
      titleList: {
        type: Array,
        default() {
          return []
        }
      },
      personList: {
        type: Array,
        default() {
          return []
        }
      },
      filterText: {
        type: String,
        default: ''
      },
      showCheckBox: {
        type: Boolean,
        default: false
      },
      tabs: {
        type: Array,
        default() {
          return []
        }
      },
      defaultChecked: {
        type: Array,
        default() {
          return []
        }
      },
      defaultPersonListChecked: {
        type: Array,
        default() {
          return []
        }
      },
      defaultPersonList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    name: "collapse-medical-record",
    data() {
      return {
        isPerson: '1',
        i: -1,
        personChecked: []
      }
    },
    methods: {
      tabChange(payload) {
        // console.log(payload)
        this.personChecked = []
        this.isPerson = payload.name
        this.$emit('tabChange', payload)
      },
      changeColl(val) {
        this.$emit('changeColl', val)
      },
      searchClick(val) {
        this.$emit('searchClick', val)
      },
      treeNodeClick(data) {
        this.$emit('treeNodeClick', data)
      },
      delPerson(val) {
        this.$emit('delPerson', val)
      },
      addPersonList(val) {
        this.$emit('addPersonList', val)
      },
      personClick(val, index) {
        this.i = index
        this.$emit('personClick', val)
      },
      checkTree(val) {
        this.$emit('checkTree', val)
      }
    },
    watch: {
      personChecked(c) {
        this.$emit('personChecked', c)
      }
    },
    created() {
      this.personListChecked = this.defaultPersonListChecked
      this.isPerson = this.tabActive
      this.personChecked = this.defaultPersonList
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

  .person_medical_record_list
    width: 100%
    height: 24px
    line-height: 24px
    text-indent: 10px
    margin-top: 4px
    i
      cursor: pointer
      display: none
      float: right
      margin-right: 10px

  .person_medical_record_list:hover
    background: #f2f2f2
    color: #00abad

  .person_medical_record_list:hover i
    display: block
    color: #898989

  .person_medical_record_list_content
    height:calc(100vh - 214px)
    overflow: auto
    overflow-x :hidden
    color: #333

  .person-item span
    display : inline-block
    width : 70%
    overflow: hidden
    text-overflow : ellipsis
    white-space : nowrap

  .checkbox_list
    width : calc(100% - 8px)
    overflow: hidden

  .checkbox_list span
    display : inline-block
    width : 80%
    overflow: hidden
    text-overflow : ellipsis
    white-space : nowrap

  .isActive
    color: #00abad
    background : #fefefe

</style>



// WEBPACK FOOTER //
// collapseMedicalRecord.vue?66c65e08